export const error_sign = 'assets/images/icn_exclamation_sign.svg';

export enum EApplicationStatus {
  ACTIVE = 'ACTIVE',
  PREQUALIFIED = 'PREQUALIFIED',
  CAPS_PREQUALIFIED = 'CAPSPREQUALIFIED',
  QUEUED = 'QUEUED',
  COMPLETED = 'COMPLETED',
  OPEN_LOAN = 'OPEN_LOAN',
  NO_BUREAU_RECORD = 'NO_BUREAU_RECORD',
  FROZEN_BUREAU = 'FROZEN_BUREAU',
  INVALID = 'INVALID',
  INVALID_SSN = 'INVALID_SSN',
  SERVER_ERROR = 'SERVER_ERROR',
  BLOCKED_SSN = 'BLOCKED_SSN',
  ABANDONED = 'ABANDONED',
}

export enum CONSUMER_NAMES {
  'abandonPrequalified',
  'consumerEmail',
  'dealerCaps',
  'dealerRefferal',
  'hotLead',
  'dealerContact',
}
export enum CONSUMER_ERRORS {
  'error',
  'processing_error',
  'timeout_error',
}

export enum EApplicationSteps {
  ONE = '1',
  TWO = '2',
  THREE = '3',
  FOUR = '4',
  FIVE = '5',
  SIX = '6',
}

export enum EloquaFormsKeys {
  ABANDON_PREQUALIFIED = 'abandonPrequalified',
  CONSUMER_EMAIL = 'consumerEmail',
  DEALER_CAPS = 'dealerCaps',
  DEALER_REFFERALS = 'dealerRefferals',
}

export enum EErrorCodes {
  NOT_AUTHORIZED = 'Not Authorized',
}
export enum PREQUAL_RESPONSE_TYPE {
  'GENERIC' = 'Generic',
  'MONTHLY_PAYMENT' = 'Monthly_Payment',
}

export const CHANNEL_TYPE = 'CONSUMER - OSM PREQUALIFICATION';
export const CHANNEL_TYPE_HOT_LEAD = 'CONSUMER - OSM HOT LEAD';
export const FORM_NOT_COMPLETED = 'N';
export const NOT_PREQUALIFIED = 'N';
export const PREQUALIFIED = 'Y';
export const FORM_COMPLETED = 'Y';
export const GENERIC_NOTE =
  'This consumer has been pre-qualified through Credit Acceptance. To complete the approval process, please submit a credit application for a specific vehicle.';

export const MAX_AMOUNT_NOTE_PRE =
  'Consumer is pre-qualified for a monthly payment up to $';
export const MAX_AMOUNT_NOTE_POST =
  ' through Credit Acceptance. The pre-qualification is valid for 30 days from the date of this note. To complete the approval process, please submit a credit application for a specific vehicle.';

export const PREQUAL_SEO = {
  title: 'Pre-Qualify Online for Auto Financing | Credit Acceptance',
  description:
    'Prequalify for auto financing online in just a few minutes. See why thousands of customers trust Credit Acceptance for their auto financing needs.',
  contentPath: '',
  searchable: true,
  type: 'webpage',
  displayDescription: true,
};
export const PREQUAL_JSON = {
  errors: {
    proferr1: 'Profanity found in the text entered.',
  },
  allRequired: 'All fields are required',
  iAgree: 'I Agree',
  buttons: {
    next: {
      label: 'Next',
    },
    back: {
      label: 'Back',
    },
  },
  openloan: {
    welcomeBack: 'Welcome Back!',
    subText1:
      'Thank you for being our customer.  We’re unable to process your pre-qualification online due to your open account. You may need to take action on the open account, such as bringing it to current, paying it off or otherwise closing the account prior to obtaining financing through Credit Acceptance.',
    subText2:
      'A Participating Dealer can confirm your next steps and possibly get you approved.',
    dealerMatch0: 'We’ll match you with 3 local dealers near',
    dealerMatch1:
      'Next, connect with the selected dealer and 2 additional dealers near',
    dealerMatch2:
      'Next, connect with the selected dealers and 1 additional dealer near',
    dealerMatch3: 'Next, connect with the selected dealers near',
    noDealersMessage:
      'To find Credit Acceptance enrolled dealerships near you, visit',
    saveMeTimeMessage1: 'Clicking',
    saveMeTimeMessage2:
      'may result in a hard credit pull that could impact your credit score.',
    iAgree: 'I Agree',
    saveMeTime: 'Save Me Time',
    seeDealers: 'SEE DEALERS',
    selectedDealers:
      'Continue below to find your next vehicle in the Credit Acceptance Network.',
  },
  success: {
    congrats: 'Congratulations!',
    successPrequalified: "You're Pre-Qualified.",
    monthlyPaymentUpTo: 'For a monthly payment up to ',
    monthlyPaymentvary:
      'Monthly payment will vary based on the vehicle you choose.',
    monthlyPaymentValidity: 'Valid for',
    monthlyPaymentValidityDays: '30 Days',
    wanttosave:
      'Want to save time on paperwork at the dealership? Your info will be sent to the three enrolled dealers so you can get a jumpstart on your credit approval!',
    openLoanError:
      'We’re unable to process your pre-qualification online, but you can still get approved for financing.',
    connectMessage:
      'Connect with an enrolled Credit Acceptance dealer below to get started.',
    findVehicleenrolledDealerShip:
      'Find your vehicle at one of these three Credit Acceptance enrolled dealerships near you!',
    noDealersMessage:
      'To find Credit Acceptance enrolled dealerships near you, visit',
    dealersExistsMessage:
      'To find Credit Acceptance enrolled dealerships near you, call our customer service number at 800-634-1506.',
    saveMeTimeMessage1: 'Clicking',
    saveMeTimeMessage2:
      'may result in a hard credit pull that could impact your credit score.',
    iAgree: 'I Agree',
    saveMeTime: 'Save Me Time',
    seeDealers: 'SEE DEALERS',
    dealerMatch0: 'We’ll match you with 3 local dealers near',
    dealerMatch1:
      'Next, connect with the selected dealer and 2 additional dealers near',
    dealerMatch2:
      'Next, connect with the selected dealers and 1 additional dealer near',
    dealerMatch3: 'Next, connect with the selected dealers near',
    selectedDealers:
      'Continue below to find your next vehicle in the Credit Acceptance Network.',
  },
  finalSuccess: {
    title: 'Congratulations!',
    subTitle: 'You’re one step closer to purchasing your vehicle.',
    prequalifiedSubTitle:
      'Your information has been sent to the three enrolled dealers near you.',
    info: 'Your information has been sent to the three enrolled dealers near you. Check your email for next steps!',
    prequalifiedContact:
      'Contact the dealers below to view their vehicle inventory.',
    prequalifiedNext24: 'They may also contact you in the next 24 hours.',
    // Copy shown only when the DVM inventory experience is active
    // (LD flag on + at least one matched pilot dealer). See SVRS-48821.
    // Split across two lines: the first sentence shares the header's first
    // line with the "Congratulations!" title; the second sentence wraps below.
    prequalifiedSubTitleInventory: 'Your info has been submitted.',
    prequalifiedSubTitleInventoryNext: 'Next, see vehicles near you.',
    prequalifiedContactInventory:
      'These dealers have received your information and will contact you.',
    inventoryIntroTitle: 'Start exploring vehicles from your dealers now.',
    inventorySparseLink: 'Find inventory from dealers near you',
  },
  residence: {
    address: 'Address',
    moveDate: 'Move in Date',
    titlePrefix: 'Hi!',
    titlePostfix: 'Where do you live?',
    subTitle:
      'Providing accurate residential information will help you pre-qualify for vehicles in your area.',
    formsFields: {
      addressLine1: {
        label: 'Home Address',
        maxLength: '41',
        errors: {
          adde1: 'Please tell us your home address.',
          adde2: 'Please enter a valid street name.',
          adde3: 'Please include a valid street number in your home address.',
        },
        isFSExclude: false,
      },
      addressLine2: {
        label: 'Unit (optional)',
        maxLength: '10',
        errors: {
          adde1: 'Unit cannot be longer than 10 characters.',
        },
        isFSExclude: false,
      },
      city: {
        label: 'City',
        maxLength: '64',
        errors: {
          citye1: 'Please tell us your city.',
          citye2: 'City may only contain letters.',
        },
        isFSExclude: false,
      },
      state: {
        label: 'State',
        isFSExclude: false,
        errors: {
          statee1: 'Please tell us your state.',
        },
      },
      zipCode: {
        label: 'Zip',
        maxLength: '5',
        isFSExclude: false,
        errors: {
          zip1: 'Please tell us your zip code.',
          zip2: 'Please enter a valid 5-digit zip code.',
          zip3: 'Please enter a valid 5-digit zip code from a U.S State or the District of Columbia.',
        },
      },
      monthResiding: {
        label: 'When did you start living here?',
        placeholder: 'MM/YYYY',
        isFSExclude: false,
        mask: '00/0000',
        errors: {
          monrese1: 'Please enter valid MM/YYYY',
          monrese2:
            'The date you entered is before your date of birth. Please enter a valid date.',
          monrese3: 'Please tell us when did you start living at residence.',
        },
      },
      ownedBy: {
        label: 'Who owns this residence?',
        title: 'Residence Own',
        isFSExclude: false,
        errors: {
          ownedbye1: 'Please tell us who owns this residence.',
        },
        options: [
          { label: 'Choose', value: '' },
          { label: 'Self', value: 'Self or Spouse' },
          { label: 'Relative', value: 'Relative' },
          { label: 'Landlord', value: 'Landlord' },
          { label: 'Military', value: 'Military' },
        ],
      },
    },
  },
  accounts: {
    title: 'What type of bank account(s) do you have?',
    subTitle:
      'For prequalification purposes, choose all the account types that you have. Account details are not requested at this time.',
    formsFields: {
      nonBanking: {
        label: 'None of the above',
        isFSExclude: false,
        errors: {
          acce1: 'At least one selection is required.',
        },
      },
    },
  },
  identification: {
    title: 'Verify your identity.',
    subTitle:
      'Providing your social security number helps verify your identity and prevent fraud. This information is securely stored and will not be shared with anyone unless you consent to do so.',
    formsFields: {
      ssn: {
        label1: 'Social Security Number (SSN)',
        label2: '- OR - Individual Taxpayer Identification Number (ITIN)',
        isFSExclude: false,
        maxLength: '11',
        mask: '000-00-0000',
        errors: {
          ide1: 'Please tell us your social security number using only numbers.',
          ide2: 'Please enter 9 digits of your SSN number.',
          ide3: 'Please enter a valid SSN.',
          ide4: 'Your social security number is invalid. Please correct your social security number.',
        },
      },
    },
  },
  summary: {
    title: 'Review what you have shared.',
    submit_information: 'Submit',
    disclaimer:
      'You will need to complete a dealership credit application so that the dealership can provide you with legally-required financing disclosures as you finalize your purchase. You will also sign a contract disclosing all your purchase and financing terms. An application at the dealership typically results in hard inquires on your credit file.',
    errors: {
      sme1: 'Your social security number is invalid. Please correct your social security number.',
      sme2: "We are unable to process your pre-qualification. The information you've provided in this form has not been retained.",
      sme3: 'Your credit file with [bureau name] has been locked or frozen. Please contact [bureau name] to unlock or unfreeze your credit file in order to proceed.',
      sme4: 'Sorry, we are unable to process your prequalification online.',
    },
  },

  income: {
    primaryIncome: 'Primary Income',
    secondaryIncome: 'Secondary Income',
    alimonyChildText:
      "You don't need to include alimony, child support, or separate maintenance income if you don't wish to have it considered as a basis for repaying this obligation.",
    buttons: {
      addSecondary: 'Add secondary source of income',
      removSecondary: 'CLEAR',
    },
    title: 'Next, please provide your income details.',
    subTitle:
      'Providing income and employment info will help you pre-qualify for vehicles in your area.',
    errors: {
      gie1: 'Your minimum bi-weekly gross income must exceed $277 to pre-qualify. Gross income will be verified prior to financing approval.',
      gie2: 'Your maximum bi-weekly gross income must not exceed $450000 to pre-qualify. Gross income will be verified prior to lending.',
    },
    formsFields: {
      incomeType: {
        label: 'Income Type',
        isFSExclude: false,
        errors: {
          ite1: 'Please tell us your income type.',
        },

        options: [
          { label: 'Choose', value: '' },
          { label: 'Employee', value: 'Employee (Gets W-2)' },
          { label: 'Self-Employed', value: 'Self-Employed (No W-2)' },
          { label: 'Fixed Income', value: 'Fixed Income (Net)' },
          {
            label: 'Temp Service Employee',
            value: 'Temp Service Employee',
          },
          { label: 'Unemployed', value: 'Unemployed' },
          { label: 'Cash Income', value: 'Cash Income' },
        ],
      },
      biWeeklyPay: {
        label: 'Bi-Weekly Gross Income',
        isFSExclude: false,
        tooltip: {
          altContent: 'biWeekly Gross Pay Tool Tip',
          content:
            'This is what you get paid, including all taxes and deductions. Please be as accurate as possible to avoid an unpleasant experience at the dealer. This information will be verified for your pre-qualification.',
        },
        maxLength: '6',
        errors: {
          bwe1: 'Please tell us your bi-weekly gross income.',
          bwe2: 'Bi-weekly income must be less than or equal to $450,000.',
          bwe3: 'Combined bi-weekly income must be less than or equal to $461,537',
        },
      },
      hireDate: {
        label: 'Start Date',
        isFSExclude: false,
        placeholder: 'MM/DD/YYYY',
        mask: '00/00/0000',
        maxLength: '10',
        errors: {
          hde1: 'Please tell us your start date.',
          hde2: 'Please enter a valid date.',
          hde3: 'The date you entered is before your date of birth. Please enter a valid date.',
          hde4: 'Start date cannot be in the future.',
          hde5: 'Hire date cannot be in the future.',
        },
      },
      employerName: {
        label: 'Employer name',
        isFSExclude: false,
        maxLength: '30',
        errors: {
          ene2: 'Please tell us your employer name.',
        },
      },
      employerPhone: {
        label: 'Employer phone',
        mask: '000-000-0000',
        isFSExclude: false,
        errors: {
          phe1: 'Please enter a valid phone number.',
          phe2: 'Please tell us your employer phone number.',
        },
      },
    },
    s_incomeType: {
      label: 'Income Type',
      isFSExclude: false,
      errors: {
        ite1: 'Please tell us your income type.',
      },

      options: [
        { label: 'Choose', value: '' },
        { label: 'Employee', value: 'Employee (Gets W-2)' },
        { label: 'Self-Employed', value: 'Self-Employed (No W-2)' },
        { label: 'Fixed Income', value: 'Fixed Income (Net)' },
        {
          label: 'Temp Service Employee',
          value: 'Temp Service Employee',
        },
        { label: 'Unemployed', value: 'Unemployed' },
        { label: 'Cash Income', value: 'Cash Income' },
      ],
    },
    s_biWeeklyPay: {
      label: 'Bi-Weekly Gross Income',
      isFSExclude: false,
      toottip: {
        altContent: 'biWeekly Gross Pay Tool Tip',
        content:
          'This is what you get paid, including all taxes and deductions. Please be as accurate as possible to avoid an unpleasant experience at the dealer. This information will be verified for your pre-qualification.',
      },
      maxLength: '6',
      errors: {
        bwe1: 'Please tell us your bi-weekly gross income.',
        bwe2: 'Bi-weekly income must be less than or equal to $450000.',
      },
    },
    s_hireDate: {
      label: 'Start Date',
      isFSExclude: false,
      placeholder: 'MM/DD/YYYY',
      mask: '00/00/0000',
      maxLength: '10',
      errors: {
        hde1: 'Please tell us your start date.',
        hde2: 'Please enter a valid date.',
        hde3: 'The date you entered is before your date of birth. Please enter a valid date.',
        hde4: 'Start date cannot be in the future.',
        hde5: 'Hire date cannot be in the future.',
      },
    },
    s_employerName: {
      label: 'Employer name',
      isFSExclude: false,
      maxLength: '30',
      rrors: {
        ene2: 'Please tell us your employer name.',
      },
    },
    s_employerPhone: {
      label: 'Employer phone',
      mask: '000-000-0000',
      isFSExclude: false,
      errors: {
        phe1: 'Please enter a valid phone number.',
        phe2: 'Please tell us your employer phone number.',
      },
    },
  },

  personal: {
    name: 'Name',
    title: 'See how much you pre-qualify for, in 2 minutes.',
    subTitle:
      'Provide your basic information to get pre-qualified for auto financing. Your information is securely stored.',
    formsFields: {
      firstName: {
        label: 'First Name',
        maxLength: '30',
        errors: {
          fne1: 'Please tell us your first name.',
        },
        isFSExclude: false,
      },
      lastName: {
        label: 'Last Name',
        maxLength: '30',
        errors: {
          lne1: 'Please tell us your last name.',
        },
        isFSExclude: true,
      },
      email: {
        label: 'Email Address',
        maxLength: '240',
        errors: {
          ee1: 'Please tell us your email.',
          ee2: 'Please enter a valid email address.',
        },
        isFSExclude: true,
        disclosure: {
          content:
            'By providing your email address, you authorize us to send you information about your pre-qualification, account(s), and other products and services offered by Credit Acceptance.',
          version: '1.0',
          createDate: '2023-05-03T02:58:00.000Z',
          updateDate: '2023-05-03T01:58:00.000Z',
        },
      },
      confirmEmail: {
        label: 'Confirm Email Address',
        maxLength: '240',
        errors: {
          cee1: 'Please confirm your email.',
          cee2: 'Confirm Email Address and Email Address provided must match.',
          cee3: 'Please enter a valid email address.',
        },
        isFSExclude: true,
      },
      dob: {
        label: 'Date of Birth',
        placeholder: 'MM/DD/YYYY',
        maxLength: '10',
        mask: '00/00/0000',
        errors: {
          dobe1: 'Please tell us your date of birth.',
          dobe2: 'Please enter a valid date.',
          dobe3: 'You must be 18 years of age.',
          dobe4: 'You must be 19 years of age.',
        },
        isFSExclude: true,
      },
      phone: {
        label: 'Phone Number',
        mask: '000-000-0000',
        errors: {
          pe1: 'Please enter a valid phone number.',
        },
        isFSExclude: false,
      },
    },
  },
  prequalFooter: {
    license:
      'Loans made or arranged pursuant to a California Finance Lenders Law license',
    copyright: 'Credit Acceptance Corporation. All rights reserved.',

    links: [
      {
        label: 'Website User Agreement and Privacy Statement',
        name: 'Website User Agreement and Privacy Statement',
        url: '/website-user-agreement-and-privacy-statement',
        tooltip: 'opens in new window',
      },
      {
        label: 'NASDAQ: CACC',
        name: 'NASDAQ: CACC',
        url: 'https://www.google.com/search?q=nasdaq:cacc',
        tooltip: 'opens in new window',
      },
      {
        label: 'Web Accessibility Policy',
        name: 'Web Accessibility Policy',
        url: '/web-accessibility-page',
        tooltip: 'opens in new window',
      },
      {
        name: 'NMLS ID: 3023',
      },
      {
        label: 'Privacy for California Residents',
        name: 'Privacy for California Residents',
        url: 'https://customer.creditacceptance.com/consumer-privacy-act',
        tooltip: 'opens in new window',
      },
      {
        label: 'Financial Privacy Policy',
        name: 'Financial Privacy Policy',
        url: '../assets/documents/legal/Privacy-Notice.pdf',
        tooltip: 'opens in new window',
      },
    ],
  },
};
